// https://vuex.vuejs.org/ja/guide/state.html

const States = {
  // 各画面で表示するタイトル
  pageTitle: '',
  // 最初にアクセスされたルート
  initialRoute: null,
  // 認証情報
  auth: null,
  // おしらせ
  notifications: [],
  // 制度・福利厚生
  welfares: [],
  // ファイル情報
  files: {
    // 申請書・マニュアルのファイル一覧
    manual: [],
    // UI UXのファイル一覧
    uiUx: [],
  },
};
export default States;
